<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="warehouseCode">
        <span slot="label">
          <a-tooltip>warehouseCode<template slot="title">warehouseCode</template></a-tooltip>
        </span>
        <a-input v-model="form.warehouseCode" :maxLength="32" disabled/>
      </a-form-model-item>
      <a-form-model-item prop="warehouseName">
        <span slot="label">
          <a-tooltip>warehouseName<template slot="title">warehouseName</template></a-tooltip>
        </span>
        <a-input v-model="form.warehouseName" :maxLength="32" disabled/>
      </a-form-model-item>
      <a-form-model-item prop="realName">
        <span slot="label">
          <a-tooltip>contact name<template slot="title">contact name</template></a-tooltip>
        </span>
        <a-input v-model="form.realName" :maxLength="32" :placeholder="$t('请输入')+'收货人'"/>
      </a-form-model-item>
      <a-form-model-item prop="mobile">
        <span slot="label">
          <a-tooltip>mobile<template slot="title">mobile</template></a-tooltip>
        </span>
        <a-input v-model="form.mobile" :maxLength="32" />
      </a-form-model-item>
      <a-form-model-item prop="areaxId">
        <span slot="label">
          <a-tooltip>地区<template slot="title">地区</template></a-tooltip>
        </span>
        <a-cascader :options="areaList"
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                    style="width: 100%" v-model="companyLocationSelected" allowClear @change="onCompanyLocationChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="detailedAddress">
        <span slot="label">
          <a-tooltip>detailedAddress<template slot="detailedAddress">mobile</template></a-tooltip>
        </span>
        <a-input v-model="form.detailedAddress" :maxLength="128" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>

  </a-drawer>
</template>

<script>
import { getWarehouse, addWarehouse, updateWarehouse } from '@/api/warehouse/warehouse'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import city from '@/views/shipping/shippingTemplate/modules/city.vue'
import {cityArea} from "@/api/logistics";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    city,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      areaList: [],
      companyLocationSelected: [],
      loading: '',
      // 表单参数
      form: {
        id: null,

        warehouseCode: null,
        warehouseName: null,
        realName: null,
        mobile: null,
        longitude: null,
        latitude: null,
        areapId: null,
        areap: null,
        areacId: null,
        areac: null,
        areaxId: null,
        areax: null,
        detailedAddress: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      },
      showCityType: 1
    }
  },
  filters: {},
  created() {
    this.getAreaTree()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        realName: null,
        mobile: null,
        longitude: null,
        latitude: null,
        areapId: null,
        areap: null,
        areacId: null,
        areac: null,
        areaxId: null,
        areax: null,
        detailedAddress: null,
      }

    },
    getAreaTree() {
      cityArea().then(response => {
        this.areaList = response.data
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWarehouse({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateWarehouse(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addWarehouse(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    handleShowCity() {
      this.showCityType = 1
      this.$refs.city.empty()
      this.$refs.city.addressModal = true
    },
    handleShowReturnCity() {
      this.showCityType = 2
      this.$refs.city.empty()
      this.$refs.city.addressModal = true
    },
    handleCitySelected(value) {
      console.log('handleCitySelected, value : ', this.showCityType, value)

    },
    /*省市区的选择, onchange方法*/
    onCompanyLocationChange(value, selectedOptions) {
      console.log(selectedOptions,'省区')
      this.form.areaxId = value[2]
    },
  }
}
</script>
